module.exports = __webpack_public_path__ + "img/12.6f5e0b9d.jpg";